import React, { useState } from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, size = "w-4 h-4", className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} data-testid="star-display">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`${size} ${n <= Math.round(value) ? "text-amber-400 fill-amber-400" : "text-brand-line"}`} />
      ))}
    </div>
  );
}

export function StarInput({ value, onChange, size = "w-7 h-7" }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex items-center gap-1" data-testid="star-input">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} data-testid={`star-${n}`}>
          <Star className={`${size} transition-colors ${n <= (hover || value) ? "text-amber-400 fill-amber-400" : "text-brand-line"}`} />
        </button>
      ))}
    </div>
  );
}
